import 'styled-components';
import { DefaultTheme } from 'styled-components';

enum THEME_TYPE {
  LIGHT = 'light',
  DARK = 'dark',
}

declare module 'styled-components' {
  export interface DefaultTheme {}
}

export type { DefaultTheme };
export { THEME_TYPE };
